<div class="workflow-events">
  <h2 class="workflow-events__title">Events</h2>
  <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="10px">
    <app-mat-text-input
      *ngIf="events.length > 10"
      class="workflow-events__search-input"
      [prefixIcon]="'search'"
      [formControl]="searchControl"
      placeholder="Search"
    >
    </app-mat-text-input>
    <div
      *ngFor="let event of filteredEvents"
      class="workflow-events__item"
      fExternalItem
      [fData]="event"
      [fDisabled]="event.disabled"
      [matTooltip]="event.description"
      fxLayout="row"
      fxLayoutAlign="start center"
      fxLayoutGap="10px"
      matTooltipPosition="right"
      (click)="eventClicked.next(event)"
    >
      <mat-icon>{{ event.icon }}</mat-icon>
      {{ event.name }}
    </div>
  </div>
</div>
